<div mat-dialog-container>
    <mat-progress-bar class="margin" [color]="color" [mode]="'determinate'" [value]=100></mat-progress-bar>
    <h1 mat-dialog-title>{{title}}</h1>
    <mat-dialog-content [innerHTML]="message"></mat-dialog-content>
    <div class="center">
        <button mat-raised-button color="primary" class="pad" (click)="close(true)">{{buttonTitle}}</button>
    </div>
</div>